import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Brand identifier for the store. Used for brand-specific styling */
  brand: PropTypes.oneOf(['anf', 'kids', 'hol', 'gh', 'st']).isRequired,
  /** Content to display on the right side of the card (e.g., action buttons, details, or custom nodes) */
  children: PropTypes.node.isRequired,
  /** The first logo to display on the left side of the store card */
  firstLogo: PropTypes.node,
  /** The second logo to display on the left side of the store card. If present, a plus icon is shown between logos */
  secondLogo: PropTypes.node,
  /** Store map or hours link, or an embedded map */
  storeMap: PropTypes.node,
  /** Name of the store, displayed on the left side */
  storeName: PropTypes.string
};
function StoreCard(_ref) {
  var brand = _ref.brand,
    children = _ref.children,
    storeName = _ref.storeName,
    storeMap = _ref.storeMap,
    firstLogo = _ref.firstLogo,
    secondLogo = _ref.secondLogo;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "store-card-jsx",
    "data-brand": brand,
    "data-testid": "store-card"
  }, firstLogo || storeName || storeMap ? /*#__PURE__*/React__default.createElement("div", {
    className: "store-card-left-container",
    "data-testid": "store-card-left-container"
  }, firstLogo ? /*#__PURE__*/React__default.createElement("div", {
    className: "store-card-logo-container",
    "data-testid": "store-card-logo-container"
  }, firstLogo, secondLogo ? /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    "data-icon": "plus",
    "data-testid": "plus-sign"
  }) : null, secondLogo) : null, storeName ? /*#__PURE__*/React__default.createElement("p", {
    className: "store-name",
    "data-testid": "store-name"
  }, storeName) : null, storeMap) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "store-card-right-container",
    "data-testid": "store-card-right-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "store-card-content"
  }, children)));
}
StoreCard.propTypes = propTypes;

export { StoreCard as default };
//# sourceMappingURL=StoreCard.js.map
